import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {MessageItem} from "../../components/other/CommentsContainer/CommentsContainer";


interface WelcomeChainType {
    abroadModal: boolean
    step: number
    onBoardingRoute: boolean
}

const initialState: WelcomeChainType = {
    step: 1,
    abroadModal: false,
    onBoardingRoute: false
}

const welcomeChainSlice = createSlice({
    name: 'welcomeChain',
    initialState,
    reducers: {
        closeAbroadModal: (state, action: PayloadAction<boolean>) => {
            state.abroadModal = action.payload;
        },
        setOnBoardingRoute: (state, action: PayloadAction<boolean>) => {
            state.onBoardingRoute = action.payload;
        },
        setAbroadModal: (state, action: PayloadAction<boolean>) => {
            state.abroadModal = action.payload;
        }
    },
});

export const { closeAbroadModal, setAbroadModal, setOnBoardingRoute } = welcomeChainSlice.actions;
export default welcomeChainSlice.reducer;